"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ErrorSvg = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  flex-direction: column;\n  color: #fff;\n\n  svg {\n    color: #ffbf00;\n    margin-bottom: 8px;\n  }\n  p {\n    font-size: 16px;\n    color: rgba(255, 255, 255, 0.85);\n    line-height: 24px;\n  }\n  span {\n    font-size: 14px;\n    color: rgba(255, 255, 255, 0.65);\n    font-weight: 300;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var ErrorSvg = function ErrorSvg(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    width: 28,
    height: 28
  }, props), /*#__PURE__*/_react.default.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M14 0C6.269 0 0 6.269 0 14s6.269 14 14 14 14-6.269 14-14S21.731 0 14 0zm0 25.625C7.581 25.625 2.375 20.419 2.375 14S7.581 2.375 14 2.375 25.625 7.581 25.625 14 20.419 25.625 14 25.625z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.5 8.5a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0zM14.75 12h-1.5a.25.25 0 00-.25.25v8.5c0 .137.113.25.25.25h1.5a.25.25 0 00.25-.25v-8.5a.25.25 0 00-.25-.25z"
  })));
};

exports.ErrorSvg = ErrorSvg;

var ErrorWrapper = _styledComponents.default.div(_templateObject());

var _default = function _default(_ref) {
  var isBigfish = _ref.isBigfish,
      message = _ref.message,
      tips = _ref.tips;
  return /*#__PURE__*/_react.default.createElement(ErrorWrapper, null, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      maxWidth: '45%'
    }
  }, /*#__PURE__*/_react.default.createElement(ErrorSvg, null), /*#__PURE__*/_react.default.createElement("p", null, isBigfish ? 'Bigfish' : 'Umi', " ", message.offline), /*#__PURE__*/_react.default.createElement("span", null, tips || message.restart)));
};

exports.default = _default;